import type { BootstrapPayload } from "./types";

export const emptyPayload: BootstrapPayload = {
  products: [],
  opportunities: [],
  watchRules: [],
  impact: [],
  sourceStatus: [],
  sourcingPulse: []
};
